import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { ROLE_HOME } from "@/lib/nav";
import { Loader2 } from "lucide-react";

function FullLoader() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50">
      <Loader2 className="h-8 w-8 animate-spin text-sky-500" />
    </div>
  );
}

export function ProtectedRoute({ roles, children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <FullLoader />;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={ROLE_HOME[user.role]} replace />;
  return children;
}

// Pages hidden from District/Campus Admin read-only "View dashboard" sessions.
export function NotViewOnly({ children }) {
  const { user } = useAuth();
  if (user?.view_only) return <Navigate to={ROLE_HOME[user.role]} replace />;
  return children;
}

export function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <FullLoader />;
  if (user) return <Navigate to={ROLE_HOME[user.role]} replace />;
  return children;
}

export { FullLoader };
